import { createSlotRecipe } from './runtime';

const switchRecipeConfig = {"name":"switchRecipe","className":"switch","slots":["root","track","thumb","label"],"defaultVariants":{"labelPosition":"end","size":"md"},"variantMap":{"labelPosition":["end","start"],"size":["sm","md","lg"]}}

export const switchRecipe = /* @__PURE__ */ createSlotRecipe(switchRecipeConfig)